import { render, staticRenderFns } from "./OrderedWarehouseItemsReport.vue?vue&type=template&id=25c40d8c"
import script from "./OrderedWarehouseItemsReport.vue?vue&type=script&lang=js"
export * from "./OrderedWarehouseItemsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports